import { XYCHART_MESSAGES } from '../messages/messages.js';

/**
 * Determines the appropriate message to display based on selection state.
 *
 * @param selectedDatapoints - Total number of selected datapoints
 * @param seriesCount - Number of series with selected datapoints (optional)
 * @param categoriesCount - Number of categories with selected datapoints (optional)
 * @returns The appropriate message definition for the current selection state
 */
export const getDatapointsMessage = (
  selectedDatapoints: number,
  seriesCount: number,
  totalChartSeries: number,
  categoriesCount: number = 0,
) => {
  if (!selectedDatapoints) {
    return XYCHART_MESSAGES.noDatapoints;
  }

  const isSingleSeriesWithoutCategories =
    totalChartSeries === 1 && !categoriesCount;
  const isMixedSelection = seriesCount > 0 && categoriesCount > 0;

  if (isSingleSeriesWithoutCategories || isMixedSelection) {
    if (selectedDatapoints === 1) {
      return XYCHART_MESSAGES.datapoint;
    } else {
      return XYCHART_MESSAGES.datapoints;
    }
  }

  if (seriesCount) {
    return XYCHART_MESSAGES.seriesDatapoints;
  }

  return XYCHART_MESSAGES.categoriesDatapoints;
};
